<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a></a></li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
    <li class="active"><a>All Inventories</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>
<div class="Content_outer">
    <div class="content_view">
      <div class="row">
        <div class="col-md-12">
          <div class="Inventory_outer">
              <div class="filter_div">
                <div class="left">
                    <h4>All Inventories - {{totleInventorysonList}}</h4>
                    <p>{{deviceTypeName}}<span>({{deviceDetailName}})</span></p>
                </div>
                <div class="right">
                    <span class="custom_select_outer width_150">
                      <select class="custom_select form-control" #t (change)="filterMethod(t.value)">
                        <option *ngFor="let filter of filterList"  [value]="filter.title"> {{filter.title}}</option>
                      </select>
                    </span>
                    <span class="custom_select_outer width_150">
                      <select class="custom_select form-control" #f (change)="filterMethodSecond(f.value)">
                        <option *ngFor="let filtertwo of filterListTwo"  [value]="filtertwo.title">
                          {{filtertwo.title}}</option>
                      </select>
                    </span>
                    <div class="custom_search width_200">
                      <span class="sprite_icon search"></span>
                      <input type="text" class="form-control" placeholder="Search" #macInput
                      (input)="searchData($event.target.value)">
                    </div>
                    <button mat-raised-button color="primary" (click)="addNewInvenDevice(deviceTypeID)">
                      <span class="sprite_icon plus_white"></span>
                      <span>Add Inventories</span>
                    </button>
                    <button mat-raised-button color="primary" (click)="searchData('')">
                      <span>Clear Mac Address</span>
                    </button>
                </div>
              </div>



              <div class="table-responsive">
                <table class="table table-hover unbordered_tb">
                  <thead>
                    <tr>
                      <th>Device Serial</th>
                      <th>Mac Address<span>(Firmware Version)</span></th>
                      <th (click)="sortByStatus()">Registration Status</th>
                      <th>Health Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let listItem of deviceInventoryList;let idx = index;">
                      <td>{{listItem.name}}</td>
                      <td>{{listItem.mac_address}} ({{listItem?.installed_firmware_version || 'Not mentioned'}})</td>
                      <td>{{listItem.status}}</td>
                      <td>
                        <span *ngIf="listItem.health==='HEALTHY'" class="label_green">Good</span>
                        <span *ngIf="listItem.health==='LIVE'" class="label_green">Good</span>
                        <span *ngIf="listItem.health==='ERROR'" class="label_red">Unacceptable</span>
                        <span *ngIf="listItem.health ==='UNHEALTHY'"  class="label_yellow">Unsatisfactory</span>
                      </td>
                      <td class="text-right">
                        <div class="actions dropdown">
                            <button class="btn dropdown-toggle" type="button" [matMenuTriggerFor]="menu" data-toggle="dropdown">
                              <span class="sprite_icon ellipse_black"></span>
                            </button>
                            <mat-menu #menu="matMenu">
                              <div class="client_action">
                                <span style="display: grid;padding: 5px; gap: 5px;">
                                  <button mat-stroked-button color="primary" (click)="editInfoNew(listItem, idx)" class="edit-button" >
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                  </button>
                                  <button mat-stroked-button color="warn" (click)="showDeleteDialog(listItem.id, idx)" class="delete-button" >
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>
                                  </button>
                                </span>


                              </div>
                            </mat-menu>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="showEmptyError !== ''" class="no_result" >
                <p>{{showEmptyError}}</p>
              </div>
          </div>
        </div>
      </div>
    </div>
</div>
